import React from 'react';


export default ({color}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
      <path class="a" fill={color || '#1a9de8'} d="M393.5,63.5h-5.25a.75.75,0,0,1-.75-.75V62a1.5,1.5,0,0,0-1.5-1.5h-4.5A1.5,1.5,0,0,0,380,62V74a1.5,1.5,0,0,0,1.5,1.5h12A1.5,1.5,0,0,0,395,74V65A1.5,1.5,0,0,0,393.5,63.5Zm0,9.75a.75.75,0,0,1-.75.75h-10.5a.75.75,0,0,1-.75-.75V62.75a.75.75,0,0,1,.75-.75h3a.75.75,0,0,1,.75.75v.75a1.5,1.5,0,0,0,1.5,1.5h5.25a.75.75,0,0,1,.75.75Zm-3.75-3.75a.75.75,0,0,1-.75.75h-.75V71a.75.75,0,0,1-1.5,0v-.75H386a.75.75,0,0,1,0-1.5h.75V68a.75.75,0,0,1,1.5,0v.75H389A.75.75,0,0,1,389.75,69.5Z" transform="translate(-380 -60.5)"/></svg>
  )
}